<template>
  <v-bottom-sheet v-model="show" inset persistent>
    <div class="popup">
      <div class="d-flex popup__header pa-2 text-center v-card-h2" />

      <div class="pa-2 popup__content">
        <div class="v-card-h1 mb-4">Pobierz aplikację</div>

        <p>
          i korzystaj ze swojej karty mieszkańca
          <b>nawet bez internetu!</b>
        </p>

        <v-row>
          <v-col cols="6" class="px-0">
            <v-btn
              aria-label="Zamknięcie okienka"
              color="primary"
              elevation="0"
              block
              large
              outlined
              @click="hidePopup"
            >
              Nie chcę
            </v-btn>
          </v-col>

          <v-col cols="6" class="px-0">
            <v-btn large color="primary" elevation="0" :to="{ name: 'instruction' }">Zobacz jak</v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-bottom-sheet>
</template>

<script>
import { mapState } from 'vuex';

// @vuese
// Popup
// @group components
export default {
  computed: {
    ...mapState({
      popup: state => state.system.popup
    }),
    isPWA() {
      return window.matchMedia('(display-mode: standalone)').matches;
    },
    show() {
      return this.popup && !this.isPWA;
    }
  },
  methods: {
    // @vuese
    // Ukrywanie popup'a
    hidePopup() {
      this.$store.commit('system/hidePopup');
    }
  }
};
</script>

<style></style>
